export const projects = [
    {
        title: 'To-Do-List',
        img: 'https://github.com/AlessandraRomualdo/To-Do-List-React/blob/main/screenshts/todo-list.gif?raw=true',
        description: 'Página web para adicionar tarefas do dia a dia. ',
        tecnologies: ['Front-end', 'React'],
        reposotorio: 'https://github.com/AlessandraRomualdo/To-Do-List-React',
        deploy: 'https://to-do-list-react-henna.vercel.app/',
    },
    {
        title: 'Music-Tunes',
        img: 'https://github.com/AlessandraRomualdo/TrybeTunes/blob/main/imgs/tunes.gif?raw=true',
        description: 'Página web para ouvi trechos de musicas e criar uma lista de favoritas, com consumo da API do iTunes. ',
        tecnologies: ['Front-end', 'React', 'API', 'React Router'],
        reposotorio: 'https://github.com/AlessandraRomualdo/TrybeTunes',
        deploy: 'https://trybe-tunes-self.vercel.app/',
    },
    {
        title: 'Tryunfo',
        img: 'https://github.com/AlessandraRomualdo/Tryunfo/blob/main/app.gif?raw=true',
        description: 'Página Web para cadastrar cartas do tipo do jogo Trunfo. ',
        tecnologies: ['Front-end', 'React'],
        reposotorio: 'https://github.com/AlessandraRomualdo/Tryunfo',
        deploy: 'https://trynfo.vercel.app/',
    },
    {
        title: 'Wallet',
        img: 'https://github.com/AlessandraRomualdo/Wallet/blob/main/screenshots/wallet.gif?raw=true',
        description: 'Uma página para registrar despesas com cotação de moeda. Cotações feitas de uma API.',
        tecnologies: ['Front-end', 'React', 'Redux', 'API'],
        reposotorio: 'https://github.com/AlessandraRomualdo/Wallet',
        deploy: 'https://wallet-lovat-five.vercel.app/',
    },
   {
        title: 'Pesquisa-de-CEP',
        img: 'https://github.com/AlessandraRomualdo/pesquisa-cep/blob/main/buscar-cep.gif?raw=true',
        description: 'Página com fech em uma API de Cep para pesquisa de endereço.',
        tecnologies: ['Front-end', 'JavaScript', 'API', 'DOM'],
        reposotorio: 'https://github.com/AlessandraRomualdo/pesquisa-cep',
        deploy: 'https://pesquisa-cep-gules.vercel.app/',
    },
    {
        title: 'Pixel-art',
        img: 'https://github.com/AlessandraRomualdo/Pixel-art/blob/main/pixel-art.gif?raw=true',
        description: 'Projeto feito para a Trybe de manipulação de DOM e criação de elementos HTML pelo JavaScript.',
        tecnologies: ['Front-end', 'JavaScript', 'DOM'],
        reposotorio: 'https://github.com/AlessandraRomualdo/Pixel-art',
        deploy: 'https://alessandraromualdo.github.io/Pixel-art/',
    },
    {
    title: 'Game-Trivia',
    img: 'https://github.com/AlessandraRomualdo/Game-Trivia/blob/main/img-public/trivia.gif?raw=true',
    description: 'Projeto feito em React com Redux de um jogo tipo trivia com consumo de uma API de jogo Trivia.',
    tecnologies: ['Front-end', 'React', 'Redux'],
    reposotorio: 'https://github.com/AlessandraRomualdo/Game-Trivia',
    deploy: 'https://game-trivia-sage.vercel.app/',
    },
];


/*{
    title: '',
    img: '',
    description: '',
    tecnologies: [],
    reposotorio: '',
    deploy: '',
},*/